// Values must match the backend Xmedical.Domain.PracticePatientAppointments.Clash
// .AppointmentClashType enum (sent as ints over the wire).
export enum AppointmentClashType {
  Practitioner = 0,
  Location = 1
}

/**
 * A single overlapping appointment returned by the clash-check endpoint
 * (GET /v1/appointments/clashes). `clashType` says whether the existing
 * appointment collides on the practitioner or the location. Times are zone-less
 * practice wall-clock strings, like all appointment start/end values.
 */
export interface AppointmentClash {
  id: number;
  title: string | null;
  start: string;
  end: string | null;
  locationId: number;
  locationName: string | null;
  practitionerId: number;
  practitionerName: string | null;
  patientName: string | null;
  clashType: AppointmentClashType;
}
